import ProjectCard from "../PageLayout/ProjectCard";
import ProjectHeader from "../Projects/ProjectHeader";
import { ProjectType } from "../Utils/ProjectType.ts";
import sharedStyles from "./music-shared.module.css";



export default function TambourineMan() {



    return (
        <ProjectCard projectName={"Mr Tambourine Man"}>

            <ProjectHeader title="MR TAMboURInE maN" subTitle="Jan / Ben" projectType={ProjectType.Music} />

            <p>I’m a big fan of Bob Dylan’s early folk work, especially the album “The Times They Are A-Changing”. Recording this with Ben was great! Once we got a take we liked, he jumped in and overdubbed harmonies in a single go, first try, no preparation! So effortless; very cool!</p>

            <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/C89Czzmg-9E" title="Bob Dylan - Mr Tambourine Man (Cover by Jan and Ben)" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

        </ProjectCard>
    )
}